import React, { useState } from "react";
import "../style/registro.css";

export default function Registro() {
    const [formData, setFormData] = useState({
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        confirmPassword: "",
        aceptarPoliticas: false
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.aceptarPoliticas) {
            alert("Debes aceptar las políticas de privacidad para continuar.");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            alert("Las contraseñas no coinciden.");
            return;
        }

        try {
            const res = await fetch("https://agro-nexus-prod.vercel.app/api/registro", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            const data = await res.json();

            if (res.ok) {
                setSuccessMessage(true);
                setTimeout(() => {
                    setSuccessMessage(false);
                    window.location.href = "/login";
                }, 2500);
            } else {
                alert(data.message || "Error al registrar el usuario.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("No se pudo conectar con el servidor.");
        }
    };

    const EyeIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    );

    const EyeOffIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a19.8 19.8 0 0 1 5.06-5.94M9.88 9.88A3 3 0 1 0 14.12 14.12M1 1l22 22" />
        </svg>
    );

    return (
        <div className="registro-container">
            {successMessage && (
                <div className="mensaje-exito">
                    ✅ Usuario creado correctamente
                </div>
            )}

            <form className="registro-form" onSubmit={handleSubmit}>
                <h2>Registro de Usuario</h2>

                <div className="input-group">
                    <label>Nombre</label>
                    <input
                        type="text"
                        name="nombre"
                        placeholder="Ingresa tu nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="input-group">
                    <label>Apellido</label>
                    <input
                        type="text"
                        name="apellido"
                        placeholder="Ingresa tu apellido"
                        value={formData.apellido}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="input-group">
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="ejemplo@correo.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="input-group">
                    <label>Celular</label>
                    <input
                        type="tel"
                        name="celular"
                        placeholder="300 000 0000"
                        value={formData.celular}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="input-group password-group">
                    <label>Contraseña</label>
                    <div className="password-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder="Ingresa tu contraseña"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        <button
                            type="button"
                            className="toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? EyeOffIcon : EyeIcon}
                        </button>
                    </div>
                </div>

                <div className="input-group password-group">
                    <label>Confirmar Contraseña</label>
                    <div className="password-wrapper">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            name="confirmPassword"
                            placeholder="Repite tu contraseña"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                        <button
                            type="button"
                            className="toggle-password"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        >
                            {showConfirmPassword ? EyeOffIcon : EyeIcon}
                        </button>
                    </div>
                </div>

                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        name="aceptarPoliticas"
                        checked={formData.aceptarPoliticas}
                        onChange={handleChange}
                    />
                    <label>
                        Acepto las <a href="#">políticas de privacidad</a> y términos de uso
                    </label>
                </div>

                <button type="submit" className="btn-registrar">Registrarse</button>

                <p className="login-link">
                    ¿Ya tienes cuenta? <a href="/login">Inicia sesión</a>
                </p>
            </form>
        </div>
    );
}
